type FormCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
};

export function FormCheckbox({ checked, onChange, label, disabled }: FormCheckboxProps) {
  return (
    <label
      className={`flex items-center gap-2.5 min-w-0 ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <input
        type="checkbox"
        className="sr-only"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span
        className={`w-4 h-4 rounded border flex items-center justify-center flex-shrink-0 transition-colors ${
          checked ? 'bg-green-600 border-green-600' : 'bg-white border-gray-300'
        }`}
        aria-hidden
      >
        {checked ? <i className="ri-check-line text-white text-xs leading-none" /> : null}
      </span>
      <span className="text-xs text-gray-800 truncate">{label}</span>
    </label>
  );
}
